import { render, staticRenderFns } from "./alarms-report.vue?vue&type=template&id=19b1779e&"
import script from "./alarms-report.vue.js?vue&type=script&lang=js&"
export * from "./alarms-report.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports